module.exports = __webpack_public_path__ + "img/reservation.98762a4d.png";